import { createI18n } from 'vue-i18n';
import { availableLocales } from '@/config/locales.js';

const fallbackLocale = {
	'es-MX': ['es-ES'],
	'ca-ES': ['es-ES'],
	default: ['es-ES'],
};

const locale = JSON.parse(localStorage.getItem('locale')) || 'es-ES';

const i18n = createI18n({
	legacy: false,
	globalInjection: true,
	locale, 
	fallbackLocale, 
});

updateLocale(locale);

export async function updateLocale(code) {
    try {
        const file = availableLocales.find(locale => locale.code === code)?.file;
        const messages = await import(`./messages/${file}.json`);
        
        i18n.global.setLocaleMessage(code, messages.default);
    
        i18n.global.locale.value = code;
    } catch (error) {
        console.error('Error updating locale', error);
    }
}

export default i18n; 